module.exports = "<mat-form-field>\n  <mat-select [ngClass]=\"cssClass\" [placeholder]=\"text\" [(ngModel)]=\"selectedValue\" name=\"item\" (change)=\"onChange(selectedValue)\" >\n    <mat-option *ngFor=\"let item of itemsVal\" [value]=\"item.value\" [disabled]=\"item.disabled\">\n      <app-list-item [item]=\"item\" [mdIcon]=\"item.mdIcon\"></app-list-item>\n    </mat-option>\n  </mat-select>\n</mat-form-field>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/select/select.component.html
// module id = ./src/app/shared/select/select.component.html
// module chunks = main